import { CheckCircleOutline, HighlightOff } from "@material-ui/icons";
import { Box } from "@mui/material";
import { CurrencyDisplay, StatusChip } from "components";
import { formatDate, textCapitalization } from "utils";

export const columnTableSongResults = [
  {
    name: "song_title",
    title: "Song",
  },
  {
    name: "status",
    title: "Status",
    renderText: item => {
      const success = item === "success";
      return (
        <Box color={success ? "green" : "red"}>
          {success ? <CheckCircleOutline /> : <HighlightOff />}
        </Box>
      );
    },
  },
  {
    name: "all",
    title: "Message",
    renderText: item => (
      <StatusChip
        type={item?.status === "success" ? "success" : "danger"}
        label={item?.message}
      />
    ),
  },
  {
    name: "line_number",
    title: "Line Number",
  },
];
export const columnTableInvoice = ({ isComposerInvoice, isModalTable }) => [
  ...(isModalTable
    ? []
    : [
        {
          name: "invoice_date",
          title: "Invoice Date",
          renderText: date => formatDate(date),
        },
      ]),
  {
    name: "invoice_number",
    title: "Invoice Number",
  },
  ...(isComposerInvoice
    ? [
        {
          name: "reference",
          title: "Reference",
          renderText: item => (item ? item : "-"),
        },

        {
          name: "payment_number",
          title: "Payment Number",
        },
        {
          name: "composer_name",
          title: "Composer",
        },
        {
          name: "invoice_value",
          title: "Invoice Value",
          headerAlign: "right",
          renderText: item => (
            <CurrencyDisplay value={item} decimalScale={2} prefix="Rp" />
          ),
        },
        {
          name: "generated_by",
          title: "Generated by",
        },
      ]
    : [
        {
          name: "dsp_name",
          title: "Client Name",
        },
        {
          name: "period",
          title: "Period",
        },
        {
          name: "type",
          title: "Type",
          renderText: item => (
            <StatusChip
              label={textCapitalization(item)}
              type={
                optionsInvoiceType?.find(value => value?.value === item)
                  ?.color || ""
              }
            />
          ),
        },
        ...(isModalTable
          ? []
          : [
              {
                name: "exchange_rate",
                title: "Exchange Rate",
                headerAlign: "right",
                renderText: item => (
                  <CurrencyDisplay value={item} decimalScale={2} prefix="Rp" />
                ),
              },
              {
                name: "all",
                title: "Origin Currency",
                headerAlign: "right",
                renderText: item => (
                  <CurrencyDisplay
                    value={item?.original_currency_revenue}
                    decimalScale={2}
                    prefix={`${item?.dsp_currency_symbol}`}
                  />
                ),
              },
            ]),
        {
          name: "base_currency_revenue",
          title: isModalTable ? "Value" : "Base Currency",
          headerAlign: "right",
          renderText: item => (
            <CurrencyDisplay value={item} decimalScale={2} prefix="Rp" />
          ),
        },
        {
          name: "total",
          title: "Total",
          headerAlign: "right",
          renderText: item => (
            <CurrencyDisplay value={item} decimalScale={2} prefix="Rp" />
          ),
        },
      ]),
  {
    name: "status",
    title: "Status",
    renderText: status => (
      <StatusChip
        label={
          optionsInvoiceStatus?.find(value => value?.value === status)?.name ||
          "-"
        }
        type={
          optionsInvoiceStatus?.find(value => value?.value === status)?.color ||
          ""
        }
      />
    ),
  },
];
export const columnTableInvoiceSongDetail = ({
  hideColumnRemainingRevenue,
  hideColumnPublisherRevenue,
  paymentComposer,
  hideSalesInvoiceNo,
}) => [
  ...(hideSalesInvoiceNo
    ? []
    : [
        {
          name: "sales_invoice_number",
          title: "Sales Invoice No",
        },
      ]),
  {
    name: "song_title",
    title: "Song Title",
  },
  {
    name: "iswc",
    title: "ISWC",
  },
  {
    name: "client_name",
    title: "Client Name",
  },
  {
    name: "period",
    title: "Report Period",
  },
  ...(paymentComposer
    ? []
    : [
        {
          name: "revenue",
          title: "Revenue",
          renderText: revenue => (
            <CurrencyDisplay
              value={revenue}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
          headerAlign: "right",
        },
        ...(hideColumnPublisherRevenue
          ? []
          : [
              {
                name: "publisher_revenue",
                title: "Publisher Revenue",
                renderText: revenue => (
                  <CurrencyDisplay
                    value={revenue}
                    decimalScale={2}
                    suffix=",-"
                    prefix="Rp"
                  />
                ),
                headerAlign: "right",
              },
            ]),
      ]),
  ...(hideColumnRemainingRevenue
    ? []
    : [
        {
          name: "composer_revenue",
          title: "Composer Revenue (Remaining)",
          renderText: revenue => (
            <CurrencyDisplay
              value={revenue}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
          headerAlign: "right",
        },
      ]),
  {
    name: "paid",
    title: "Paid",
    renderText: item => (
      <CurrencyDisplay value={item} decimalScale={2} suffix=",-" prefix="Rp" />
    ),
    headerAlign: "right",
  },
];
export const optionsInvoiceType = [
  {
    name: "Claim",
    value: "claim",
    color: "success",
  },
  {
    name: "Usage",
    value: "usage",
    color: "active",
  },
];
export const optionsInvoiceStatus = [
  {
    name: "Draft",
    value: "draft",
    color: "warning",
  },
  {
    name: "Waiting for Approval",
    value: "waiting_for_approval",
    color: "warning",
  },
  {
    name: "Waiting for Approval (Payment)",
    value: "waiting_for_approval_payment",
    color: "warning",
  },
  {
    name: "Approved",
    value: "approved",
    color: "success",
  },
  {
    name: "Paid Updating Dashboard",
    value: "paid_updating_dashboard",
    color: "warning",
  },
  {
    name: "Paid",
    value: "paid",
    color: "success",
  },
  {
    name: "Rejected",
    value: "rejected",
    color: "danger",
  },
];
export const optionsStatusComposerPayment = [
  {
    name: "Requested",
    value: "requested",
    color: "warning",
  },
  {
    name: "Processed",
    value: "processed",
    color: "active",
  },
  {
    name: "Paid",
    value: "paid",
    color: "success",
  },
  {
    name: "Rejected",
    value: "rejected",
    color: "danger",
  },
];
export const chipInvoiceStatus = [
  ...optionsInvoiceStatus,
  { name: "Active", value: "active", color: "success" },
  { name: "Unpaid", value: "unpaid", color: "danger" },
];
